<template>
    <main-table-layout
        sub-menu-selector="adminpanel"
    >
        <div slot="buttonsRight"/>
        <content-filter
                slot="filter"
                @filter="filtering"
                :id="'permissionList'"
                store-name="Permission"
        />

            <view-switcher
                slot="mainContentButtons"
                :id="'mainContent'"
                :table="true"
                :thumbnails="true"
            />
        <pagination
                slot="mainContentButtons"
                :limit="paginationLimit"
                :total="$store.getters.getPermissionListOptions(listName, 'pagination_items')"
                :id="'permissiontablepage'"
                @setActive="loadPaginatedData"
                ref="pagination"
        />
        <Button
            permission="createPermission"
            type="action-button" slot="mainContentButtons" link="/admin/permissions/add" icon="plus">
                {{ $t('createNewType', {type: $t('permission')}) }}
        </Button>
<Button
           slot="mainContent"
           @click="loadPaginatedData(0); $refs.pagination.setActive(0)"
           type="reload"
           icon="redo"
           class="icon-button"
       />
            <table-widget
                    v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'table'"
                    slot="mainContent"
                    @sort="sort"
                    :id="'permissionsDefaultTable'"
                    :nav-by-clicking-row="true"
                    :deletable="true"
                    @deleteRow="deleteRow"
                    :show-tags="true"
                    :show-organization="true"
                    :fields="tableFields"
                    :data="$store.getters.getPermissionsByListName('PermissionList')"
                    :title-as-links="true"
                    :key="forceReRenderKey"
                    edit-permission="editPermission"
                    delete-permission="deletePermission"
                    resource="Permission"
                    :loading="loading"
            />
            <thumbnails
                    v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'thumbnails'"
                    slot="mainContent"
                    @sort="sort"
                    :id="'permissionsDefaultThumbnails'"
                    :deletable="true"
                    @deleteRow="deleteRow"
                    :nav-by-clicking-row="true"
                    edit-permission="editPermission"
                    delete-permission="deletePermission"
                    :fields="thumbnailFields"
                    :data="$store.getters.getPermissionsByListName('PermissionList')"
                    :title-as-links="true"
                    :key="forceReRenderKey"
                    resource="Permission"
                    :loading="loading"
            />
    </main-table-layout>
</template>

<script>
    import Button from "../components/forms/Button";
    import ContentFilter from "../components/widgets/filter/ContentFilter";
    import MainTableLayout from "../layouts/MainTableLayout";
    import ViewSwitcher from "../components/widgets/ViewSwitcher";
    import Thumbnails from "../components/widgets/ThumbnailView";
    import Pagination from "../components/Pagination";
    import { mapState } from 'vuex';
    import TableWidget from "@/components/widgets/TableWidget";
    export default {
        name: "Permissions",
        components: {
            Button,
            TableWidget,
            ContentFilter,
            MainTableLayout,
            ViewSwitcher,
            Thumbnails,
            Pagination,
        },
        data() {
            return {
                loading: true,
                listName: 'PermissionList',
                offset: 0,
                filter: {},
                sorting: '-updatedAt',
                paginationLimit: 15,
                queryRelevantComponents: 2, //pagination and filter
                queryRelevantInits: 0,
                viewId: 'mainContent',
                forceReRenderKey: 0,
                tableFields: [
                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                    {
                        name: 'Name',
                        id: 'name',
                        type: 'string',
                        sortable: true
                    },
                  {
                    name: 'DisplayName',
                    id: 'displayName',
                    type: 'displayName',
                    sortable: true
                  },
                    {
                        name: 'Last Update',
                        id: 'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
                thumbnailFields: [
                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                    {
                        name: 'Last Update',
                        id: 'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Name',
                        id: 'name',
                        type: 'string',
                        sortable: true
                    },
                  {
                    name: 'DisplayName',
                    id: 'displayName',
                    type: 'displayName',
                    sortable: true
                  },
                    {
                        name: 'Tags',
                        id:'tags',
                        type: 'tags',
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
            };
        },
        computed: mapState({pages: state => state.page.pages,}),
        watch: {
            queryRelevantInits: function(newval) {
                if(newval === this.queryRelevantComponents) {
                    this.loadPermissions();
                }
            }
        },
        methods: {
          loadPermissions(initial = false) {
            this.loading = true;
              let args = {
                listName: this.listName
              };
              const paginationAddOn = {
                limit: {
                  default: this.paginationLimit
                },
                offset: {
                  default: this.offset,
                },
                paging: {
                  default: true
                },
                sort: {
                  [this.listName]: this.sorting,
                }
              }
              args.add = this.filter.add ? {...paginationAddOn, ...this.filter.add } : paginationAddOn;
              if(this.filter.remove) {args.remove = this.filter.remove}
              if(!initial || this.queryRelevantInits >= this.queryRelevantComponents) {
                this.$store.dispatch('loadPermissions', args).then(data => {
                  this.list = data;
                  this.loading = false;
                });
              } else {
                this.$store.dispatch('registerPermissionQueryParams', {listName: this.listName, params: args});
              }
            },
            deleteRow: function(id) {
                this.$store.dispatch('deletePermission', {
                    args: [id]
                });
            },
            filtering(val, initial) {
              this.queryRelevantInits++;
              this.filter = val;
              this.loadPermissions(initial);
            },
            loadPaginatedData(offset, initial) {
              this.queryRelevantInits++;
              this.offset = offset;
              this.loadPermissions(initial);
            },
            sort(args) {
              const {fieldname, direction} = args;
              const sortString = direction + fieldname;
              if(this.sorting !== sortString) {
                this.sorting = sortString;
              }
              this.loadPermissions(false);
            }
        }
    }
</script>